import React from 'react';

interface ProgressBarProps {
  percentage: number;
  height?: string;
  backgroundColor?: string;
  fillColor?: string;
  showPercentage?: boolean;
}

export default function ProgressBar({ 
  percentage, 
  height = '8px', 
  backgroundColor = 'rgba(255, 255, 255, 0.1)',
  fillColor = 'var(--orange)',
  showPercentage = false 
}: ProgressBarProps) {
  const clampedPercentage = Math.min(100, Math.max(0, percentage));
  
  return (
    <div style={{ width: '100%', position: 'relative' }}>
      <div style={{
        width: '100%',
        height,
        backgroundColor,
        borderRadius: '9999px',
        overflow: 'hidden',
        position: 'relative',
      }}>
        <div 
          style={{
            height: '100%',
            width: `${clampedPercentage}%`,
            background: `linear-gradient(90deg, ${fillColor} 0%, rgba(20, 254, 251, 0.8) 100%)`,
            transition: 'width 0.5s ease-out',
            borderRadius: '9999px',
            boxShadow: `0 0 10px ${fillColor}`,
          }}
        />
      </div>
      {showPercentage && (
        <span style={{
          position: 'absolute',
          right: 0,
          top: '50%',
          transform: 'translateY(-50%)',
          fontSize: '11px',
          fontWeight: 'bold',
          color: 'var(--orange)',
          marginLeft: '8px',
        }}>
          {clampedPercentage.toFixed(0)}%
        </span>
      )}
    </div>
  );
}

